/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * EQUAL operator looks for values that are equal to the given value.
 */
export interface EqualKeyType {
    /** The value to compare against. */
    value: Truvity.EqualKeyTypeValue;
}
